<template>
  <div>
    <div>
      <!-- <a-button type="primary" @click="showModal"
        >Open Modal of 1000px width</a-button
      > -->
      <a-modal
        :footer="false"
        :open="isOpen"
        title="Create Depot Group"
        @cancel="handleOk"
      >
        <form class="my-10" @submit.prevent="createDepotGroup">
          <div class="my-4">
            <LabelText :forVal="'group name'" labelText="Group Name" />

            <DrawerInput
              type="text"
              placeholder="Enter Group Name"
              name="groupName"
              v-model="groupName"
            />
          </div>

          <div class="mt-3">
            <LabelText :forVal="'description'" labelText="Description" />

            <DrawerInput
              type="text"
              placeholder="Enter description"
              name="groupName"
              v-model="description"
            />
          </div>

          <div class="my-4">
            <SubmitButton :val="'Create depot'" :loading="this.loading" />
          </div>
        </form>
      </a-modal>
    </div>
  </div>
</template>

<script>
//services
import depotService from "@/services/depot-service";

//libraries
import { useToast } from "vue-toastification";

//components
import LabelText from "@/components/UI/Text/LabelText.vue";
import DrawerInput from "@/components/UI/Inputs/DrawerInput.vue";
import SubmitButton from "@/components/UI/Inputs/FormSubmitInput.vue";

export default {
  name: "CreateDepotGroupModal",
  props: ["isOpen", "getDepotGroups", "handleOk"],
  components: {
    LabelText,
    DrawerInput,
    SubmitButton,
  },
  data() {
    return {
      groupName: null,
      description: "",
      loading: false,
      toast: useToast(),
    };
  },

  methods: {
    //requests
    async createDepotGroup() {
      this.loading = true;
      if (!this.groupName) {
        this.toast.error("Enter a group name");
        this.loading = false;
        return;
      }

      try {
        const data = {
          name: this.groupName,
          description: this.description,
        };
        const result = depotService.createDepotGroup(data);
        if (result) {
          setTimeout(() => {
            this.getDepotGroups();
            this.loading = false;

            this.groupName = null;
            this.description = "";
            this.handleOk();
          }, 1000);
        }
      } catch (err) {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>
